<select [disabled]="disabled || !options || options.length ===0"
        required
        [(ngModel)]="selectedOption">
  <option value=""
          *ngIf="!disableEmptyOption"></option>
  <option *ngFor="let option of options"
          [ngValue]="keyField ? option[keyField] : option"
          [label]="getLabel(option) | translate"></option>
</select>
